import * as React from "react";
import { Link } from "react-router-dom";

/*===========================================================================
  Card
/*======================================================================== */

interface CardProps {
    children?: React.ReactNode
    className?: string
    linkTo?: string
    ribbon?: React.ReactNode
    title: string
    id?: string
}

export const Card: React.SFC<CardProps> = (props) => {
    const classes = ["c-card"];
    if(props.className) classes.push(props.className);
    return (
        <div className={classes.join(" ")}>
            {props.linkTo && (
                <Link to={props.linkTo}>
                    <div className="c-card__outer">
                        <div className="c-card__inner">
                            {props.ribbon}
                            <div className="c-card__title">{props.title}</div>
                            <div className="c-card__divider" />
                            {props.children}
                        </div>
                    </div>
                </Link>
            )}
            {!props.linkTo && (
                <div className="c-card__outer">
                    <div className="c-card__inner">
                        {props.ribbon}
                        <div className="c-card__title">{props.title}</div>
                        <div className="c-card__divider" />
                        {props.children}
                    </div>
                </div>
            )}
        </div>
    );
}


/*===========================================================================
  Card > CardItem
/*======================================================================== */

interface CardItemProps {
    bullet?: boolean
    dotted?: boolean
    children: React.ReactNode
}

export const CardItem = (props: CardItemProps) => {
    const classes = ["c-card__item"];
    if(props.bullet) classes.push("c-card__item--bullet");
    if(props.dotted) classes.push("c-card__item--dotted");
    return <div className={classes.join(" ")}>{props.children}</div>;
}

export default Card;
